export function getNotificationPayload(notification: any): Record<string, any> {
  if (notification?.data && typeof notification.data === "object") {
    return notification.data;
  }
  if (notification?.metadata && typeof notification.metadata === "object") {
    return notification.metadata;
  }
  return {};
}

export function isAchievementUnlockedNotification(notification: any): boolean {
  const payload = getNotificationPayload(notification);
  return (
    String(notification?.type || "").toLowerCase() === "achievement_unlocked" ||
    String(payload?.kind || "").toLowerCase() === "achievement_unlocked"
  );
}

export function getAchievementUnlockedName(notification: any): string {
  const payload = getNotificationPayload(notification);
  const payloadName = String(payload?.achievementName || payload?.name || "").trim();
  if (payloadName) return payloadName;

  const message = String(notification?.message || "").trim();
  if (message.toLowerCase().startsWith("you unlocked:")) {
    return message.slice("you unlocked:".length).trim();
  }

  return String(notification?.title || "Achievement").trim() || "Achievement";
}

export function getAchievementUnlockedMessage(notification: any): string {
  const name = getAchievementUnlockedName(notification);
  return `You unlocked: ${name}`;
}

export function shouldShowAchievementConfetti(notification: any): boolean {
  const payload = getNotificationPayload(notification);
  return Boolean(payload?.confetti) && Number(payload?.tier ?? 0) >= 3;
}

export function isBellEligibleNotification(notification: any): boolean {
  const type = String(notification?.type || "").toLowerCase();
  if (type !== "trade_offer") return false;

  const payload = getNotificationPayload(notification);
  const direction = String(payload?.direction || "").toLowerCase();
  const status = String(payload?.status || "").toLowerCase();

  if (direction === "sent") return false;
  if (status === "rejected") return false;
  return true;
}
